
import { Alert, Button, Form, Modal } from "react-bootstrap";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import { MuniSpinner2 } from "../../../components";
import { useEffect, useState } from "react";
import useActas from "../../../api/actas";
import useMotivos from "../../../api/motivos";
import { useMotivosStore } from "../../../store/motivosStore";
import { useActaDetalleStore } from "../../../store/actaDetalleStore";
import { useLocation } from "react-router-dom";


const ModalConfirm = ({ titleModal, titleMensaje, setRefetch, mensaje, variant, confirm }) => {
    const path = useLocation().pathname
    const { modals, handlerModal, loads } = useGeneralAppStore();
    const { acta } = useActaDetalleStore()
    const { anularActa } = useActas()
    const { getMotivos } = useMotivos()
    const { motivos } = useMotivosStore();

    const [motivo, setMotivo] = useState("");
    const [opcionMotivo, setOpcionMotivo] = useState("No selecciono motivo");
    const [otro, setOtro] = useState();


    useEffect(() => {
        if (!motivos && !path.includes('/actas-anuladas')) {
            getMotivos();
        }
    }, [])


    return (
        <>


            <Modal
                show={modals.includes('modal_confirm')}
                onHide={() => handlerModal({ modal: false, modalName: "modal_confirm" })}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                style={{
                    backgroundColor: modals.length > 1 && modals[0] === 'acta_detalle' ? 'rgba(0,0,0,0.4)' : '',
                    // opacity: modals.length > 1 && modals[0] === 'acta_detalle' ? '.1' : '1',        
                }}
            // className="position-relative"
            >
                <div className="position-relative">
                    {
                        (loads.includes('modal_confirm') || loads.includes('motivos')) &&
                        <div className=" d-flex justify-content-center align-items-center position-absolute w-100 h-100 z-3" style={{ backgroundColor: "rgba(255,255,255,0.7)" }}>
                            <MuniSpinner2 />
                        </div>
                    }
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            {titleModal}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {
                            !path.includes('/actas-anuladas')
                                ?
                                <div className="d-flex flex-column gap-2 ">
                                    <h4 className="text-danger">{titleMensaje}</h4>
                                    <Alert variant="danger" className="primary m-0">
                                        Seleccione un motivo por cual sera anulada el acta.
                                    </Alert>
                                    <Form.Select onChange={(e) => {
                                        if (e.target.value == "") {
                                            setOpcionMotivo("No selecciono motivo")
                                        }
                                        else {
                                            if (e.target.value != "12") {
                                                setOtro(null)
                                            }
                                            setOpcionMotivo(e.target.value)
                                        }
                                    }}>
                                        <option value="">Seleccione motivo</option>
                                        {
                                            motivos?.map((motivo) => {
                                                return (
                                                    <option key={motivo.id} value={motivo.id}>{motivo.nombre}</option>
                                                )
                                            }
                                            )
                                        }
                                        {/* <option value="6">Otro</option> */}
                                    </Form.Select>
                                </div>
                                :
                                <div className="d-flex flex-column gap-2">
                                    <h4 className="text-danger">{titleMensaje}</h4>
                                    <Alert variant="danger" className="primary m-0">
                                        Confirme la anulación del acta.
                                    </Alert>
                                </div>
                        }
                        {
                            opcionMotivo == '10' &&
                            <Form.Control rows={"3"} className="mt-3" style={{ resize: "none" }} as={'textarea'} placeholder="Escriba el motivo de la anulación . . ." onChange={(e) => {
                                setOtro(e?.target.value)
                            }}></Form.Control>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        {
                            !path.includes('/actas-anuladas')
                                ?
                                <Button onClick={() => anularActa({ id: acta.id, motivo_id: opcionMotivo, motivo: otro }, setRefetch, handlerModal)} disabled={((opcionMotivo == "No selecciono motivo") || (opcionMotivo == '12' && !otro))} variant={`${((opcionMotivo == "No selecciono motivo") || (opcionMotivo == '12' && !otro)) ? "secondary" : "danger"}`}>confirmar</Button>
                                :
                                <Button onClick={() => anularActa({ id: acta.id, motivo_id: opcionMotivo }, setRefetch)} variant={`danger`}>confirmar</Button>

                        }
                        <Button onClick={() => handlerModal({ modal: false, modalName: "modal_confirm" })}>cancelar</Button>
                    </Modal.Footer>
                </div >
            </Modal >


        </>
    );
}
export default ModalConfirm;